export class TwoFactorAuthenticationDto  {

    public userId :string;
    public twoFactorCode :string;
    }
    